

import React, { useRef } from 'react';
import { Field, ErrorMessage, useField } from "formik";
import '../CustomInputLogin/CustomInputLogin.css';
import { BiBorderRadius } from 'react-icons/bi';
import { FaStarOfLife } from 'react-icons/fa6';

const CustomDateInput = ({ label, name, editData,important, ...rest }) => {
  const [field, meta] = useField(name);

  // Get today's date in YYYY-MM-DD format
  const today = new Date().toISOString().split("T")[0];
  const dateInputRef = useRef(null);

  const handleClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker(); // for modern browsers
      dateInputRef.current.focus();      // fallback for others
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div style={{ width: "96%" }} >
        <div
          style={{ marginBottom: "7px" }}
        >
          <label
            htmlFor={name}
            className="input-heading12"
            style={{ fontSize: "16px", fontWeight: "400" }}
          >
            {label}
            {important && (
              <FaStarOfLife style={{ color: '#F53E5C', fontSize: "8px", marginLeft: "3px", marginBottom: "4px" }} />
            )}
          </label>
        </div>

        <Field
          onClick={handleClick}
          {...field}
          id={name}
          name={name}
          ref={dateInputRef}
          type="date"
          placeholder="Enter Input"
          // min={editData ? undefined : today} // Disable past dates
          {...rest}
          className='custominput-field12'
          style={{ borderRadius: "3px" }}
        />
        <ErrorMessage name={name} component="div" className="inputs-error-msg" style={{ color: "red", fontSize: "10px" }} />
      </div>
    </div>
  );
};

export default CustomDateInput;

